export default __webpack_public_path__ + "static/media/extra_cheese.3d4ca763.png";